<template>
    <div class="main">
      <Header
        :logo-white="false"
        :button="true"
        :background="true"
      />
      <PageHeader 
        :back= true
        title="" 
        sub-title="Over ons"
      />
      <div class="flex-grid">
        <div class="col-2">
          <div class="content">
            <p class="intro">
              De woningmarkt is een bijzondere 'markt'
            </p>
            <p>
              iSalu hebben we vrij vertaald uit het Deens en betekent 'in de verkoop'.
              Dit vinden we passen bij ons unieke concept, speciaal ontworpen om jou zelfverzekerd de woningmarkt te laten betreden.     
            </p>
            <p>
              Stappen op de woningmarkt zijn mogelijke de belangrijkste stappen die jij ooit gaat zetten. Natuurlijk omdat het gaat om je (t)hius. Maar ook
              financieel zeer belangrijk voor nu en later. Essentieel dus om zelfverzekerd en goed voorbereid deze bijzondere 'markt' te betreden.
            </p>
            <p>
              Met iSalu gaan we onze kennis bijeen brengen, om die aan jou aan te bieden. Geregeld zullen we nieuwe kennis beschikbaar maken via blogs en zullen we nieuwe 
              partners selecteren die jou verder kunnen helpen.
            </p>          
            <p>
              Voor ons heel belangrijk. Jij behoudt de regie. Neem de kennis zonder kosten tot je en kies zelf met welke partners je in zee wenst te gaan. Geen verplichtingen. 
              Aan jou de keuze!!
            </p>          
          </div>
        </div>
        <div class="col-2">
          <div class="content">
            <p class="intro">
              Vragen?
            </p>
            <p>
              Mail naar;
              <a href="mailto:info@isalu.nl">info@isalu.nl</a>
            </p>
  
            <div class="team">
              <div class="team-member text-center">
                <div>
                  <img
                    src="@/isaluAssets/img/team/bill-statisch.jpg"
                    alt
                  >
                  <img
                    src="@/isaluAssets/img/team/bill.gif"
                    alt
                  >
                </div>
                <div class="name text-tertiary">
                  Bill
                </div>
                <div class="position">
                  Head Product
                </div>
              </div>
              <div class="team-member text-center">
                <div>
                  <img
                    src="@/isaluAssets/img/team/programmeurs.jpg"
                    alt
                  >
                  <img
                    src="@/isaluAssets/img/team/programmeurs.gif"
                    alt
                  >
                </div>
                <div class="name text-tertiary">
                  Briljant Groepje
                </div>
                <div class="position">
                  Programmeurs
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="flex-grid">
        <div class="col-2">
          <div class="content text-center">
            <p>
              <strong>
                Zelfverzekend de woningmarkt betreden. Welkom bij iSalu
              </strong>
            </p>
          </div>
        </div>
        <div class="col-2">
          <div class="content text-center">
            <p>
              <strong>
                iSalu is een handelsnaam van iSalu B.V. ingeschreven
                in de Kamer van Koophandel met KVK nummer 77281055
              </strong>
            </p>
          </div>
        </div>
      </div>
    </div>
  </template>
  <script>
  import Header from "@/components/ComponentHeader";
  import PageHeader from "@/components/ComponentPageHeader";
  import { mapGetters } from "vuex";
  
  export default {
    name: "MoreInfo",
    components: {
      Header,
      PageHeader
    },
    computed: {
      ...mapGetters(["showVideo"])
    }
  };
  </script>
  <style scoped>
  .container--stretch {
    align-items: stretch;
  }
  
  .col-2:first-child {
    margin: 0 0 0 2%;
  }
  
  .col-2:last-child {
    margin: 0 2% 0 0;
  }
  
  .coll-2--full {
    flex-basis: 50%;
    padding: 20px 40px;
    position: relative;
    height: calc(100vh - 180px);
    display: flex;
    justify-content: center;
  }
  
  .content {
    margin-top: 40px;
    width: 100%;
    padding: 0 10px;
    position: relative;
  }
  
  .intro {
    font-size: 20px;
    margin-top: 0;
  }
  
  .image {
    position: absolute;
    left: 0;
  }
  
  .mirror {
    transform: scaleX(-1);
  }
  
  .image.middle {
    bottom: 0;
    right: 0;
    left: 0;
    margin: 0 auto;
    text-align: center;
  }
  
  .moreinfo {
    position: absolute;
    bottom: 20px;
    left: 40px;
  }
  
  @media (max-width: 720px) and (min-width: 240px) {
    .coll-2--full {
      flex-basis: 100%;
      min-height: 250px;
    }
  
    .content {
      width: 100%;
      margin-top: 20px;
    }
  
    .col-2 {
      margin: 0 2%;
    }
  }
  
  .team {
    margin-top: 20px;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
  }
  
  .team-member {
    position: relative;
    width: 100%;
  }
  
  .team-member img:last-child {
    opacity: 0;
    display: none;
  }
  
  .team-member img {
    transition: opacity 0.2s ease-in-out;
  }
  
  .team-member:hover img:first-child {
    opacity: 0;
    display: none;
  }
  
  .team-member:hover img:last-child {
    opacity: 1;
    display: block;
  }
  
  .team-member:not(:first-child) {
    margin-left: 2%;
  }
  </style>
  